import React from 'react';
import FormattedText from './FormattedText';

export default function TextMessage({ message }) {
  return <FormattedText text={message.text} />;
}
